// Judge.me レビューフォーム内の利用規約・プライバシーポリシーのリンクを自店舗URLへ差し替える
// Judge.me の仕様で GDPR 文言（リンク含む）はアプリ設定から変更不可のため、DOM側で書き換える
(function () {
  var JUDGEME_LINK_MAP = {
    'judge.me/terms': '/pages/terms-of-service',
    'judge.me/privacy': '/pages/privacy-policy'
  };

  function rewriteJudgeMeLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var anchors = scope.querySelectorAll('a[href*="judge.me/terms"], a[href*="judge.me/privacy"]');
    anchors.forEach(function (anchor) {
      Object.keys(JUDGEME_LINK_MAP).forEach(function (pattern) {
        if (anchor.href.indexOf(pattern) !== -1) {
          anchor.setAttribute('href', JUDGEME_LINK_MAP[pattern]);
        }
      });
    });
  }

  function watchJudgeMeWidget() {
    rewriteJudgeMeLinks(document);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            rewriteJudgeMeLinks(/** @type {Element} */ (node));
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchJudgeMeWidget);
  } else {
    watchJudgeMeWidget();
  }
})();

// 汎用的なトグル開閉関数
/**
 * @param {Object} options
 * @param {string} options.containerSelector
 * @param {string} options.itemSelector
 * @param {string} options.triggerSelector
 * @param {string} options.contentSelector
 * @param {string} [options.toggleButtonSelector]
 * @param {string} [options.openClass]
 * @param {string} options.globalFlag
 * @param {string} options.itemDataFlag
 * @param {string} [options.animationDuration]
 * @param {Function} [options.onToggle]
 */
function initializeAccordion(options) {
    console.log('[FAQ Accordion] initializeAccordion called with options:', options);
    
    const {
      containerSelector,
      itemSelector,
      triggerSelector,
      contentSelector,
      toggleButtonSelector,
      openClass = 'is-open',
      globalFlag,
      itemDataFlag,
      animationDuration = '0.3s',
      onToggle = null
    } = options;
  
    // 重複実行を防ぐ
    const globalFlagKey = globalFlag;
    // @ts-ignore - dynamic property access
    if (globalFlagKey && window[globalFlagKey]) {
      console.log('[FAQ Accordion] Already initialized, skipping');
      return;
    }
    // @ts-ignore - dynamic property access
    if (globalFlagKey) {
      // @ts-ignore - dynamic property assignment
      window[globalFlagKey] = true;
      console.log('[FAQ Accordion] Global flag set:', globalFlagKey);
    }
  
    // 実行関数
    const executeAccordion = function() {
      console.log('[FAQ Accordion] executeAccordion called');
      console.log('[FAQ Accordion] Looking for containers with selector:', containerSelector);
      const containers = document.querySelectorAll(containerSelector);
      console.log('[FAQ Accordion] Found containers:', containers.length);
  
      containers.forEach(function(container) {
        console.log('[FAQ Accordion] Processing container');
        const items = container.querySelectorAll(itemSelector);
        console.log('[FAQ Accordion] Found items:', items.length);
  
        items.forEach(function(item, index) {
          // 既に初期化済みの場合はスキップ
          const dataFlagKey = itemDataFlag;
          const itemHTMLElement = /** @type {HTMLElement} */ (item);
          if (dataFlagKey && itemHTMLElement.dataset && itemHTMLElement.dataset[dataFlagKey] === 'true') {
            console.log('[FAQ Accordion] Item', index, 'already initialized, skipping');
            return;
          }
  
          console.log('[FAQ Accordion] Initializing item', index);
          const trigger = item.querySelector(triggerSelector);
          const content = item.querySelector(contentSelector);
          const toggleButton = toggleButtonSelector ? item.querySelector(toggleButtonSelector) : null;
  
          console.log('[FAQ Accordion] Item', index, '- trigger:', trigger, 'content:', content, 'toggleButton:', toggleButton);
  
          if (!trigger || !content) {
            console.warn('[FAQ Accordion] Item', index, '- Missing trigger or content, skipping');
            return;
          }
  
          // HTMLElementにキャスト
          const contentElement = /** @type {HTMLElement} */ (content);
          const itemElement = /** @type {HTMLElement} */ (item);
  
          // 初期設定
          contentElement.style.maxHeight = '0px';
          contentElement.style.overflow = 'hidden';
          contentElement.style.transition = 'max-height ' + animationDuration + ' ease';
  
          // 初期状態でopenクラスがある場合は開いた状態に設定
          if (itemElement.classList.contains(openClass)) {
            setTimeout(function() {
              contentElement.style.maxHeight = 'none';
              // 強制的に再描画を促す
              void contentElement.offsetHeight;
              const calculatedHeight = contentElement.scrollHeight;
              if (calculatedHeight > 0) {
                contentElement.style.maxHeight = (calculatedHeight + 100) + 'px';
              } else {
                contentElement.style.maxHeight = '5000px';
              }
            }, 100);
          }
  
          // クリック処理
          /**
           * @param {Event} e
           */
          const handleClick = function(e) {
            console.log('[FAQ Accordion] handleClick called for item', index);
            if (e && e.preventDefault && e.stopPropagation) {
              e.preventDefault();
              e.stopPropagation();
            }
  
            // 開閉状態の切り替え
            const isOpen = itemElement.classList.contains(openClass);
            console.log('[FAQ Accordion] Item', index, 'isOpen:', isOpen);
  
            if (isOpen) {
              // 閉じる処理
              console.log('[FAQ Accordion] Closing item', index);
              const currentHeight = contentElement.scrollHeight;
              contentElement.style.maxHeight = currentHeight + 'px';
              // 強制的に再描画を促す
              void contentElement.offsetHeight;
  
              setTimeout(function() {
                contentElement.style.maxHeight = '0px';
                itemElement.classList.remove(openClass);
                console.log('[FAQ Accordion] Item', index, 'closed, class removed');
              }, 10);
  
              // コールバック関数を呼び出し
              if (onToggle && typeof onToggle === 'function') {
                onToggle(false, contentElement);
              }
            } else {
              // 開く処理
              console.log('[FAQ Accordion] Opening item', index);
              const scrollHeight = contentElement.scrollHeight;
              console.log('[FAQ Accordion] Item', index, 'scrollHeight:', scrollHeight);
              contentElement.style.maxHeight = scrollHeight + 'px';
              itemElement.classList.add(openClass);
              console.log('[FAQ Accordion] Item', index, 'opened, class added');
  
              // アニメーション完了後にmax-heightをnoneに設定（トランジションを無効にして2段階の動きを防ぐ）
              const durationMs = parseFloat(animationDuration) * 1000;
              setTimeout(function() {
                // トランジションを一時的に無効にして、max-height: noneへの切り替えをスムーズにする
                contentElement.style.transition = 'none';
                contentElement.style.maxHeight = 'none';
                // 次のフレームでトランジションを復元
                requestAnimationFrame(function() {
                  contentElement.style.transition = 'max-height ' + animationDuration + ' ease';
                });
                console.log('[FAQ Accordion] Item', index, 'animation complete');
              }, durationMs);
  
              // コールバック関数を呼び出し
              if (onToggle && typeof onToggle === 'function') {
                onToggle(true, contentElement);
              }
            }
          };
  
          // クリックイベントを追加（質問部分）
          trigger.addEventListener('click', function(e) {
            console.log('[FAQ Accordion] Trigger clicked for item', index);
            // トグルボタンがクリックされた場合は処理しない（トグルボタンのイベントで処理）
            const target = /** @type {HTMLElement} */ (e.target);
            if (target && target.closest && target.closest('.faq-item__toggle')) {
              console.log('[FAQ Accordion] Click was on toggle button, ignoring trigger click');
              return;
            }
            handleClick(e);
          });
  
          // キーボードイベントを追加（Space または Enter キー）
          trigger.addEventListener('keydown', function(e) {
            const keyEvent = /** @type {KeyboardEvent} */ (e);
            if (keyEvent && (keyEvent.key === 'Enter' || keyEvent.key === ' ')) {
              keyEvent.preventDefault();
              handleClick(keyEvent);
            }
          });
  
          // トグルボタンのクリックイベント
          if (toggleButton) {
            console.log('[FAQ Accordion] Adding click listener to toggle button for item', index);
            toggleButton.addEventListener('click', function(e) {
              console.log('[FAQ Accordion] Toggle button clicked for item', index);
              e.stopPropagation(); // 親要素へのイベント伝播を防ぐ
              handleClick(e);
            });
            toggleButton.addEventListener('keydown', function(e) {
              const keyEvent = /** @type {KeyboardEvent} */ (e);
              if (keyEvent && (keyEvent.key === 'Enter' || keyEvent.key === ' ')) {
                keyEvent.preventDefault();
                keyEvent.stopPropagation();
                handleClick(keyEvent);
              }
            });
          }
  
          // 初期化済みマークを設定
          if (dataFlagKey && itemHTMLElement.dataset) {
            itemHTMLElement.dataset[dataFlagKey] = 'true';
          }
        });
      });
    };
  
    // DOMContentLoadedイベントが既に発生している場合は即座に実行
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', executeAccordion);
    } else {
      executeAccordion();
    }
  }